import { defineStore } from 'pinia';
import { qryFlowList } from '@tencent/wphk-act-base-cgi';
import dayjs from 'dayjs';
import { to } from '@tencent/wphk-components-common/utils/common';

/**
 * 列表类型
 */
export enum ListKind {
  /** 已储 */
  Store = '1',
  /** 已兑 */
  Exchange = '2',
}

const PAGE_SIZE = 10;

export const useRecordList = defineStore('recordList', {
  state() {
    return {
      /** 当前选中月份 */
      month: dayjs(new Date()).startOf('month')
        // 必须使用月初的1日作为起始时间，
        // 否则在时间选择器中，出现9-31日这样的日期的时候，会被格式化为10-1
        .toDate(),
      /** 当前列表类型 */
      kind: ListKind.Store,
      /** 当前列表数据 */
      data: [] as any[],
      /** 当前翻页情况 */
      pageNum: 0,
      /** 每页的数据情况 */
      pageSet: {} as any,
      /** 是否正在加载中 */
      isLoading: false,
      /** 是否已经全部加载，已经全部加载的情况下，loadMore无效 */
      isAllLoaded: false,
    };
  },
  actions: {
    async getList() {
      const { month, kind: orderType, pageNum } = this;
      const date = dayjs(month);
      const startTime = date.startOf('month').toDate();
      const endTime = date.endOf('month').toDate();
      this.isLoading = true;
      const [err, res] = await to(qryFlowList({
        startTime, endTime, orderType, pageNum, pageSize: PAGE_SIZE,
        // 限制只查狂赏印印花
        // @TAPD https://tapd.woa.com/10145891/bugtrace/bugs/view?bug_id=1010145891117317681
        qualId: 'Z%2F5Dc3FH09FSH9wcNlJV4g%3D%3D',
      }));
      this.isLoading = false;
      if (err) {
        throw err;
      }
      const { flowList } = res;
      console.log('=== flowList ===', flowList);
      return flowList;
    },
    async setMonth(month) {
      this.month = month;
      this.resetPage();
    },
    async setKind(kind) {
      this.kind = kind;
      this.resetPage();
    },
    async resetPage() {
      this.pageNum = 0;
      this.isAllLoaded = false;
      const data = await this.getList();
      this.data = data;
      this.pageSet = { 0: data };
    },
    async loadMore() {
      if (this.isAllLoaded) {
        return;
      }

      const page = this.pageNum + 1;
      this.pageNum = page;
      const newList = await this.getList();
      this.pageSet[page] = newList;

      // 后端要这么做，条数小于PAGE_SIZE的时候表示已经加载完
      if (newList.length < PAGE_SIZE) {
        this.isAllLoaded = true;
      }

      const data: any[] = [];
      let i = 0;
      let pageData = this.pageSet[i] as any;
      while (pageData) {
        data.push(...pageData);
        i += 1;
        pageData = this.pageSet[i];
      }
      this.data = data;
    },
  },
});
